import { Image, theme, Button, Tooltip } from "antd";
import { Link, useLocation } from "react-router-dom";
import LogoSmallNew from "@/assets/images/logo.png";
import ResizeIcon from "@/assets/icons/resize.png";
import styles from "../dashboardLayout.module.less";
import C from "@/utils/constants";
import { useTypedDispatch } from "@/app/store";
import { quickOrderSlide } from "@/modules/QuickOrder/quickOrder.slice";

const { useToken } = theme;
const ICON_COLOR = "#8591a6";

interface ISidebarProps {
  routes: any[];
  collapsed: boolean;
  onToggleSidebar: () => void;
  userInfo: any;
  isTablet?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Sidebar({ routes = [], collapsed = false, onToggleSidebar = () => false, userInfo = {}, isTablet = false }: ISidebarProps) {
  const { token } = useToken();
  const location = useLocation();
  const checkActive = (key: string) => (location.pathname || "").match(key) !== null;

  const dispatch = useTypedDispatch();
  const { onSelectCompany } = quickOrderSlide.actions;

  const selectCompany = (tag: string) => {
    if (tag === "orders") {
      dispatch(onSelectCompany(null));
    }
  };

  const logoStyles = {
    width: collapsed ? 160 : "100%",
    transform: collapsed ? "rotate(270deg)" : "rotate(0deg)",
    translate: collapsed ? "-53px -5px" : "0 0",
  };

  const getSideBar = () => {
    const sideBarDefault = routes.filter(({ layout, sideBar }) => layout === "admin" && sideBar && sideBar !== C.PERMISSIONS.ROLE_READ);
    const userRoleMgSidebar = routes.filter(({ layout, sideBar }) => layout === "admin" && sideBar || sideBar === C.PERMISSIONS.ROLE_READ);

    return (userInfo?.isSuperAdmin ? userRoleMgSidebar : sideBarDefault)
      .map(({ title, icon, path, tag }, index) => (
        <div className={styles.menuItem} key={index}>
          <Link
            to={path}
            className={styles.menuItemLeft}
            style={{
              background: checkActive(tag) ? token.colorPrimary : "#dfe3ef",
              borderColor: checkActive(tag) ? "#DA590E" : "#d3d8e3",
              color: checkActive(tag) ? "#fff" : "#757575",
              paddingLeft: collapsed ? 0 : 28,
            }}
            onClick={() => selectCompany(tag)}
          >
            {!collapsed && <span>{title}</span>}
          </Link>
          <Tooltip title={collapsed ? title : null} placement="right">
            <Link
              to={path}
              className={styles.menuItemRight}
              style={{
                background: checkActive(tag) ? "#DE5706" : "#d3d7e1",
                borderColor: checkActive(tag) ? "#BC4701" : "#c9cdd7",
              }}
            >
              {icon({
                color: checkActive(tag) ? "#fff" : ICON_COLOR,
              })}
            </Link>
          </Tooltip>
        </div>
      ));
  };

  return (
    <div className={styles.sidebarWrapper}>
      <div
        className={styles.imgWrapper}
        style={{
          justifyContent: collapsed ? "start" : "center",
        }}
      >
        <Image src={LogoSmallNew} style={logoStyles} preview={false} fallback={C.IMAGE_DEFAULT} />
      </div>

      <div className={styles.menuWrapper}>
        {getSideBar()}

        <div className={styles.menuItem}>
          <div
            className={styles.menuItemLeft}
            style={{
              borderBottom: 0,
            }}
          >
            {!collapsed && (
              <Button type="primary" className={styles.buttonCollapse} onClick={onToggleSidebar}>
                <Image
                  src={ResizeIcon}
                  style={{
                    width: 24,
                  }}
                  preview={false}
                  fallback={C.IMAGE_DEFAULT}
                />
              </Button>
            )}
          </div>
          <div
            className={styles.menuItemRight}
            style={{
              borderBottom: 0,
              justifyContent: "start",
            }}
          >
            {collapsed && (
              <Button
                type="primary"
                className={styles.buttonCollapse}
                style={{
                  width: 28,
                  height: 28,
                }}
                onClick={onToggleSidebar}
              >
                <Image
                  src={ResizeIcon}
                  style={{
                    width: 18,
                  }}
                  preview={false}
                  fallback={C.IMAGE_DEFAULT}
                />
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
